import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <>
      <main className="contact-page">
        <header className="contact-hero">
          <h1>Contact Us</h1>
          <p>
            Hosting a birthday, office morning tea, or need a regular bulk
            order? Tell us what you’re planning and we’ll get back to you fast.
          </p>
        </header>

        <form
          action="https://formspree.io/f/your-id" // replace with Formspree ID
          method="POST"
          className="contact-form"
        >
          {/* Honeypot (spam guard) */}
          <input
            type="text"
            name="_gotcha"
            style={{ display: "none" }}
            tabIndex="-1"
            autoComplete="off"
          />

          <div className="grid">
            <div className="field">
              <label htmlFor="name">Your name</label>
              <input id="name" name="name" type="text" required />
            </div>

            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" required />
            </div>

            <div className="field">
              <label htmlFor="phone">Phone (optional)</label>
              <input
                id="phone"
                name="phone"
                type="tel"
                placeholder="e.g. 0400 000 000"
              />
            </div>

            <div className="field">
              <label htmlFor="eventType">What’s this for?</label>
              <select id="eventType" name="eventType" defaultValue="Party">
                <option>Party / Celebration</option>
                <option>Corporate / Office</option>
                <option>Community Event</option>
                <option>Regular Wholesale / Bulk</option>
                <option>Other</option>
              </select>
            </div>

            <div className="field">
              <label htmlFor="date">Event date (if known)</label>
              <input id="date" name="date" type="date" />
            </div>

            <div className="field">
              <label htmlFor="headcount">Approx. headcount</label>
              <input
                id="headcount"
                name="headcount"
                type="number"
                min="1"
                placeholder="e.g. 40"
              />
            </div>

            <div className="field">
              <label htmlFor="fulfilment">How would you like it?</label>
              <select id="fulfilment" name="fulfilment" defaultValue="Pickup">
                <option>Pickup</option>
                <option>Delivery (local)</option>
                <option>On-site catering</option>
              </select>
            </div>

            <div className="field">
              <label htmlFor="budget">Budget (optional)</label>
              <input id="budget" name="budget" type="text" placeholder="$ -" />
            </div>
          </div>

          <div className="field">
            <label htmlFor="message">Tell us the details</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Menu ideas, dietary needs, delivery window, anything else…"
              required
            />
          </div>

          <button type="submit" className="buy-button">
            Send enquiry
          </button>

          <input type="hidden" name="_subject" value="Event/Bulk Enquiry" />
          <input type="hidden" name="source" value="contact-page" />
        </form>

        {/* Find Us + Hours */}
        <section className="contact-side fullwidth-map">
          <div className="contact-text-block">
            <h2>Find Us</h2>
            <p>Open daily, call ahead for large orders.</p>

            <p className="opening-hours">
              <strong>Open Mon to Friday:</strong> 5:00am – 2pm&nbsp;&nbsp;&nbsp;
              <strong>Open Sat:</strong> 5:00am – 11am
            </p>
          </div>

          <div className="map-embed">
            <iframe
              title="Burro Henley location"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=4%2F445%20Victoria%20Road%20Taperoo%2C%20Adelaide%2C%20South%20Australia%205017&output=embed"
            />
          </div>
        </section>
      </main>
    </>
  );
}
